import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TEMPLATES_FEATURE_KEY,
  TemplatesState,
  templatesAdapter
} from './templates.reducer';

// Lookup the 'Template' feature state managed by NgRx
export const getTemplateState = createFeatureSelector<TemplatesState>(TEMPLATES_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = templatesAdapter.getSelectors();

export const getTemplatesLoaded = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.templatesLoaded
);

export const getTemplatesLoadError = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.templatesLoadError
);

export const getAddTemplateSuccess = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.addTemplateSuccess
);


export const getAddTemplateError = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.addTemplateError
);


export const getUpdateTemplateSuccess = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.updateTemplateSuccess
);


export const getUpdateTemplateError = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.updateTemplateError
);


export const getDeleteTemplateSuccess = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.deleteTemplateSuccess
);


export const getDeleteTemplateError = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.deleteTemplateError
);


export const getQueryTemplateError = createSelector(
  getTemplateState,
  (state: TemplatesState) => state.queryTemplateLoadError
);

export const getTemplates = createSelector(getTemplateState, (state: TemplatesState) => selectAll(state));

export const getTemplatesDictionary = createSelector(getTemplateState, (state: TemplatesState) => state.entities);


export const getActiveTemplates = createSelector(getTemplates,
  (templates) =>
    templates.filter(item => item.active)
);


export const getActiveTemplatesWithCostmodel = createSelector(getActiveTemplates,
  (templates) =>
    templates.filter(item =>  item.costModel)
);


export const getTemplateById = createSelector(getTemplates,
  (templates, props) =>
    templates.find(item => item.id === props.id)
);







